import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, takeUntil, throwError, EMPTY } from 'rxjs';
import { AuthService } from '../auth.service';
import { HeaderService } from '../header.service';
import { environment } from 'src/environments/environment';
import { FACILITY_ID_URL, INGNORE_AUTH, INGNORE_AUTH_TOKEN } from 'src/app/shared/config/app.constant';
import { EndPointsEnum } from 'src/app/shared/enums/end-points';
import { RequestCancelService } from '../request.cancellation.service';
import { UserAgentService } from '../user-agent.service';
import { DeviceService } from '../device.service';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService, private headerService: HeaderService, private cancelService: RequestCancelService, private userAgentService: UserAgentService, private deviceService: DeviceService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
        const token = this.authService.authToken;
        const refreshToken = this.authService.refreshToken;
        const cid = this.authService.getLoginData.corpId;
        const fid = this.headerService.getFacilityId();
        const tenantId = environment.clientCode.toLowerCase();

        const requestHeders: any = {
            'X-TenantID': tenantId
        };
        const isIngore = INGNORE_AUTH.some(endpoint => request.url.includes(endpoint));
        const isIngoreToken = INGNORE_AUTH_TOKEN.some(endpoint => request.url.includes(endpoint));
        const facilityId = fid || 'not-found';
        if (!this.deviceService.deviceId) {
            this.deviceService.getDeviceId();
        }
        if (this.deviceService.deviceId) {
            requestHeders['deviceId'] = this.deviceService.deviceId;
        }

        if (!this.userAgentService.ua) {
            this.userAgentService.getUA();
        }
        if (this.userAgentService.ua) {
            requestHeders['X-App-User-Agent'] = this.userAgentService.ua;
        }

        if (token && refreshToken && !isIngore) {
            if (!isIngoreToken) {
                requestHeders['Authorization'] = `Bearer ${token}`;
            }

            if (fid) {
                requestHeders['fid'] = fid;
            }
            if (cid) {
                requestHeders['cid'] = cid;
            }
            if (request.url.includes(EndPointsEnum.sendBedData)) {
                requestHeders['bridge_token'] = 'HceHv3taF46lVff2KfBafasfWkKjk6WJvCf4s1wBl1Cm8G33KhMtIzhuJDyHUMfe9aS8rMw0liDQg5awO4LJtqGlCXb3QgSV29sB1pf6';

            }

            request = request.clone({
                setHeaders: requestHeders,
                url: request.url.replace(FACILITY_ID_URL, facilityId)
            });

            const authExpTime = this.authService.getJwtTokenExpiryTime(token);
            const refreshExpTime = this.authService.getJwtTokenExpiryTime(refreshToken);
            const nowTime = Date.now();
            const authTokenIsAboutToExpire = !(nowTime < authExpTime - 30000); // check before 30 secs of auth token expiry
            const authTokenIsExpired = nowTime > authExpTime; // check if token already expired in case of app stand by mode
            const refreshTokenIsAboutToExpire = !(nowTime < refreshExpTime - 30000); // check before 15 secs of refresh token expiry
            const refreshTokenIsExpired = nowTime > refreshExpTime;

            if (!refreshTokenIsAboutToExpire || !refreshTokenIsExpired) {
                if (authTokenIsAboutToExpire || authTokenIsExpired) {
                    return this.authService.getNewAccessTokenBefore401Error(request, next);
                }
            }
            return next.handle(request).pipe(
                takeUntil(this.cancelService.cancelObservable)
            );
        } else {
            request = request.clone({
                setHeaders: requestHeders,
                url: request.url.replace(FACILITY_ID_URL, facilityId)
            });
            return next.handle(request).pipe(
                takeUntil(this.cancelService.cancelObservable)
            );
        }
    }
}
